<div class="layout-topbar fixed left-0 top-0 w-full px-10 bg-surface-ground flex items-center">
    <div class="layout-topbar-logo-container flex items-center gap-4">
        @if (!isRootRoute()) {
            <button
                id="app-main-sidebar-button"
                class="layout-menu-button layout-topbar-action inline-flex justify-center items-center rounded-full w-12 h-12 min-w-[44px] min-h-[44px] text-color cursor-pointer border-none bg-transparent transition-transform duration-200"
                aria-label="Abrir ou fechar o menu lateral"
                (click)="layoutService.onMenuToggle()"
            >
                <i [ngClass]="layoutService.layoutState().staticMenuMobileActive || layoutService.layoutState().overlayMenuActive ? 'pi pi-times' : 'pi pi-bars'"></i>
            </button>
        }
        <a class="layout-topbar-logo flex items-center gap-4 text-2xl text-color no-underline" routerLink="/">
            <img src="/images/logos/sicom.svg" class="w-10 h-auto" alt="Logo SICOM" />
            <span class="tracking-tight text-emerald-500">{{ sistema() }}</span>
        </a>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <div class="relative">
                <!-- <button class="layout-topbar-action layout-topbar-action-highlight" pStyleClass="@next" -->
                <button
                    class="layout-topbar-action inline-flex justify-center items-center rounded-full w-12 h-12 text-color cursor-pointer border-none bg-transparent"
                    style="background-color: var(--primary-color)"
                    aria-label="Configurações de aparência"
                    (click)="toggleLayoutConfig()"
                >
                    <i class="pi pi-cog" style="color: var(--primary-contrast-color)"></i>
                </button>
                <app-configurator [(visible)]="layoutConfigVisible" />
            </div>
        </div>

        <div class="layout-topbar-actions-desktop hidden lg:flex items-center gap-4">
            <button type="button" class="layout-topbar-action inline-flex justify-center items-center rounded-full w-12 h-12 text-color cursor-pointer border-none bg-transparent" aria-label="Notificações" (click)="notficacoes.toggle($event)">
                <p-overlay-badge class="inline-flex" [value]="totalNotificacoes()" [badgeDisabled]="totalNotificacoes() === 0">
                    <i class="pi pi-bell"></i>
                </p-overlay-badge>
            </button>
            <!-- <button type="button" (click)="logout()" class="layout-topbar-action"> -->
            <button type="button" (click)="op.toggle($event)" aria-label="Menu do perfil" class="cursor-pointer layout-topbar-action flex items-center gap-3 bg-transparent border-none rounded-full px-1 py-1 w-auto hover:bg-surface-hover">
                @if (!photoUrl()) {
                    <p-avatar icon="pi pi-user" size="normal" class="mr-2" style="width: 36px; height: 36px; background-color: #ece9fc; color: #2a1261" shape="circle" />
                }
                @if (photoUrl()) {
                    <div class="mr-2 w-[36px] h-[36px] rounded-full overflow-hidden border border-surface">
                        <img [src]="photoUrl()" alt="Perfil" class="w-full h-full object-cover" />
                    </div>
                }
                <i class="pi pi-angle-down text-sm mr-2 text-color-secondary"></i>
            </button>
        </div>

        <button
            class="layout-topbar-menu-button layout-topbar-action lg:hidden inline-flex justify-center items-center rounded-full w-12 h-12 text-color cursor-pointer border-none bg-transparent"
            aria-label="Mais ações"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="animate-scalein"
            leaveToClass="hidden"
            leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true"
        >
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:hidden">
            <div class="layout-topbar-menu-content">
                <button type="button" class="layout-topbar-action inline-flex justify-center items-center rounded-full w-12 h-12 text-color cursor-pointer border-none bg-transparent" aria-label="Notificações" (click)="notficacoes.toggle($event)">
                    <p-overlay-badge class="inline-flex" [value]="totalNotificacoes()" [badgeDisabled]="totalNotificacoes() === 0">
                        <i class="pi pi-bell"></i>
                    </p-overlay-badge>
                </button>
                <!-- <button type="button" (click)="logout()" class="layout-topbar-action"> -->
                <button type="button" (click)="op.toggle($event)" aria-label="Menu do perfil" class="cursor-pointer layout-topbar-action flex items-center gap-3 bg-transparent border-none rounded-full px-1 py-1 w-auto hover:bg-surface-hover">
                    @if (!photoUrl()) {
                        <p-avatar icon="pi pi-user" size="normal" class="mr-2" style="width: 36px; height: 36px; background-color: #ece9fc; color: #2a1261" shape="circle" />
                    }
                    @if (photoUrl()) {
                        <div class="mr-2 w-[36px] h-[36px] rounded-full overflow-hidden border border-surface">
                            <img [src]="photoUrl()" alt="Perfil" class="w-full h-full object-cover" />
                        </div>
                    }
                    <i class="pi pi-angle-down text-sm mr-2 text-color-secondary"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<p-popover #notficacoes>
    <div class="flex flex-col gap-3 w-25rem" style="min-width: 200px">
        <div class="pt-2 px-2 notification-list border-round-lg">
            @if (notificacoes().length) {
                <div class="flex items-center justify-between mb-2">
                    <div class="text-sm font-semibold text-color">Notificações</div>
                    <button type="button" class="text-xs text-primary bg-transparent border-none cursor-pointer" (click)="limparNotificacoes()">Limpar</button>
                </div>
                @for (notificacao of notificacoes(); track notificacao.id) {
                    <p-message [severity]="notificacao.severity" [icon]="notificacao.icon" closable size="small" class="mb-2" (onClose)="removerNotificacao(notificacao.id)">
                        @if (notificacao.link) {
                            <a class="block text-left no-underline text-color hover:text-primary cursor-pointer" [routerLink]="notificacao.link" (click)="removerNotificacao(notificacao.id); fecharNotificacoes()">
                                <div class="font-semibold">{{ notificacao.summary }}</div>
                                @if (notificacao.detail) {
                                    <div class="text-sm text-color-secondary">{{ notificacao.detail }}</div>
                                }
                            </a>
                        } @else {
                            <div class="text-left">
                                <div class="font-semibold">{{ notificacao.summary }}</div>
                                @if (notificacao.detail) {
                                    <div class="text-sm text-color-secondary">{{ notificacao.detail }}</div>
                                }
                            </div>
                        }
                    </p-message>
                }
            } @else {
                <div class="py-3 text-sm text-color-secondary text-center">Nenhuma notificação.</div>
            }
        </div>
    </div>
</p-popover>

<p-popover #op>
    <!-- Submenu de Perfil -->
    <div class="flex flex-col gap-4 w-25rem" style="min-width: 160px">
        <!-- Cabeçalho do Perfil -->
        <div class="pt-4 pb-2 px-4 text-center">
            @if (!photoUrl()) {
                <p-avatar icon="pi pi-user" class="mx-auto mb-3" styleClass="text-3xl" style="width: 40px; height: 40px; background-color: #ece9fc; color: #2a1261" shape="circle" />
            }
            @if (photoUrl()) {
                <div class="mx-auto block mb-3 w-[80px] h-[80px] rounded-full overflow-hidden border border-surface shadow-md">
                    <img [src]="photoUrl()" alt="Perfil" class="w-full h-full object-cover" />
                </div>
            }
            <span class="font-bold text-lg block mb-1">Olá, {{ user()?.name }}!</span>
            <div style="padding-top: 15px">
                <button pButton label="Gerenciar sua Conta" class="p-button-secondary" (click)="profile()"></button>
            </div>
            <div class="text-center" style="padding-top: 15px">
                <a (click)="logout()" class="flex items-center gap-2 p-3 text-700 hover:surface-100 transition-colors cursor-pointer border-round">
                    <i class="pi pi-sign-out text-2xl"></i>
                    <span class="font-medium">Sair</span>
                </a>
            </div>
        </div>
    </div>
</p-popover>
